<ion-item *ngFor="let item of xmlTopics">
  <ion-icon name="information-circle-sharp" slot="start" size="large" class="hide"></ion-icon>
  <ion-label class="ion-text-wrap">
    <h2>
      <strong>{{ item.name | translate }}</strong>
    </h2>
    <h2 *ngIf="item.value !== '0' && item.value !== '1'">{{ item.value | translate }}</h2>
  </ion-label>
  <ion-icon *ngIf="item.value === '1'" name="checkmark-circle" color="primary" slot="end"></ion-icon>
  <ion-icon *ngIf="item.value === '0'" name="ellipse-outline" slot="end"></ion-icon>
</ion-item>
